module.exports = __webpack_public_path__ + "img/NavWithApartmentName.1ed6f63e.png";